export default {
      id: "training-plan-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#training-plan",
      toString: function () {
        return this.url;
      }
    }